import React from "react"
import { MedicalInfo } from "../../types/MedicalInfo"
import { AdditionalInfoQuestionKey } from "../../utils/RoutingInfoQuestionKey"
import { RoutingInfoQuestions } from "./RoutingInfoQuestions"
import { SubHeader } from "../../utils/RoutingInfoStyles"
import { VStack, Accordion, AccordionPanel, AccordionItem, AccordionButton, AccordionIcon } from "@chakra-ui/react"
import { AnythingElseMedicalAnswer } from "./AnythingElseAnswer"
import { getMedicalInfoSubHeaderText } from "./medicalInfoSubheader"
import { getAllMedicalQuestions } from "./MedicalInfoQuestions"

export type MedicalInfoDetailProps = {
  allMedicalInfo: MedicalInfo[] | null | undefined
}

export default function MedicalInfoDetail({ allMedicalInfo }: MedicalInfoDetailProps): JSX.Element | null {
  if (!allMedicalInfo || allMedicalInfo[0] == null) return null

  const firstMedicalInfo = allMedicalInfo[0]

  return (
    <AccordionSection>
      {allMedicalInfo.map((medicalInfo: MedicalInfo) => (
        <AccordionItem id={medicalInfo.medicalInfoId.toString()} key={medicalInfo.medicalInfoId} borderBottom={"0px"}>
          <AccordionItemHeader>
            <SubHeader>{getMedicalInfoSubHeaderText(medicalInfo)}</SubHeader>
          </AccordionItemHeader>
          <AccordionPanel padding={"0px"}>
            <RoutingInfoQuestions
              routingInfoQuestions={getAllMedicalQuestions(medicalInfo)}
              skipFields={medicalInfo.skipFields}
            />
            {medicalInfo.isFromCarrotPlanMenuItem && (
              <AnythingElseMedicalAnswer
                subHeader={"Additional information from medical question CP menu item"}
                questionKey={AdditionalInfoQuestionKey.MedicalAdditionalInfo}
                skipFields={firstMedicalInfo.skipFields}
                answer={firstMedicalInfo.medicalAnythingElse}
              />
            )}
          </AccordionPanel>
        </AccordionItem>
      ))}
    </AccordionSection>
  )
}

function AccordionItemHeader(props) {
  return (
    <h2>
      <AccordionButton w={"630px"} paddingLeft={"0px"} paddingRight={"0px"} justifyContent={"space-between"}>
        {props.children}
        <AccordionIcon />
      </AccordionButton>
    </h2>
  )
}

function AccordionSection(props) {
  return (
    <>
      <Accordion defaultIndex={[0]} allowMultiple>
        <VStack spacing={"27px"} align={"start"}>
          {props.children}
        </VStack>
      </Accordion>
    </>
  )
}
